module.exports = __webpack_public_path__ + "static/media/mobile-hero-img.45c9c7ff.png";